import { render, staticRenderFns } from "./ServiceEndpoints.vue?vue&type=template&id=4166eb0b&"
import script from "./ServiceEndpoints.vue?vue&type=script&lang=js&"
export * from "./ServiceEndpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4166eb0b')) {
      api.createRecord('4166eb0b', component.options)
    } else {
      api.reload('4166eb0b', component.options)
    }
    module.hot.accept("./ServiceEndpoints.vue?vue&type=template&id=4166eb0b&", function () {
      api.rerender('4166eb0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/serviceDetails/ServiceEndpoints.vue"
export default component.exports